var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

document.addEventListener('DOMContentLoaded', function () {
  initButtons();
  initGrid();
  if (getWishlist().length > 0) {
    const wishlistLink = document.querySelector('.wishlist_link');
    if (wishlistLink && wishlistLink.classList.contains('blank_wl')) {
      wishlistLink.classList.remove('blank_wl');
    }
  }
});

document.addEventListener('shopify-wishlist:updated', function (event) {
  initGrid();
});

var setupGrid = function (grid) {

  var wishlist = getWishlist();

  const textMap = ftranslations[currentLang] || ftranslations['en'];

  var html = '<div class="responsive_table"><table><tr><th><b>' + textMap.image + '</b></th><th><b>' + textMap.product + '</b></th><th><b>' + textMap.price + '</b></th><th><b>' + textMap.view + '</b></th><th><b>' + textMap.remove + '</b></th></tr>';

  var requests = wishlist.map(function (handle) {

    var productJson = getLocalePath('/products/' + handle + '.json');

    $.ajax({
      url: productJson,
      data: {},
      dataType: "json",
      complete: function (response) {
        var productObj = JSON.parse(response.responseText);

        $.each(productObj, function (i, val) {

          if (val.image != null) {
            var dispimg = val.image.src;
          } else {
            var dispimg = window.theme.placeholder_image || '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_250x250.gif';
          }

          html = html + '<tr id="rw-' + val.id + '"><td class="wish_pic"><img width="100" src="' + dispimg + '" alt="' + val.title + '"></td><td>' + val.title + '</td><td>$' + val.variants[0].price + '</td><td><a class="btn btn_xs" href="' + getLocalePath('/products/' + handle) + '">' + textMap.shop_now + '</a></td><td><span class="close_W_row"><a id="' + handle + '" href="javascript:void(0);" class="remove btn btn_xs">' + textMap.remove_btn + '</a></span></td></tr>';

          $('#wishlistdiv').html(html);

        });

        $('table').on('click', 'tr a.remove', function (e) {
          e.preventDefault();
          updateWishlist(this.id);
        });

      }
    });

    /*var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });*/


  });

  $('#wishlistdiv').html('</table></div>');


  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });

    document.dispatchEvent(event);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
      toggleWishText(button, true)
    }
    button.addEventListener('click', function () {
      updateWishlist(productHandle);
      let isActive = button.classList.toggle(BUTTON_ACTIVE_CLASS);
      toggleWishText(button, isActive);
      const wishlistLink = document.querySelector('.wishlist_link');
      if (getWishlist().length > 0) {
        wishlistLink.classList.remove('blank_wl');
      } else {
        if (!wishlistLink.classList.contains('blank_wl')) {
          wishlistLink.classList.add('blank_wl');
        }
      }
    });
  });
};

const ftranslations = {
  en: {
    favorite: "Favorite",
    favorited: "Favorited",
    image: "Image",
    product: "Product",
    price: "Price",
    view: "View",
    remove: "Remove",
    shop_now: "Shop Now",
    remove_btn: "Remove"
  },
  fr: {
    favorite: "Préféré",
    favorited: "Favorisé",
    image: "Image",
    product: "Produit",
    price: "Prix",
    view: "Voir",
    remove: "Retirer",
    shop_now: "Acheter maintenant",
    remove_btn: "Retirer"
  }
};

const currentLang = Shopify.locale;

function getLocalePath(path) {
  if (currentLang === 'fr') {
    return '/fr' + path;
  }
  return path;
}

function toggleWishText(button, isActive) {
  let favText = button.querySelector('.aftr_wish');

  if (favText) {
    const textMap = ftranslations[currentLang] || ftranslations['en'];

    favText.textContent = favText.textContent.trim() === textMap.favorited
      ? textMap.favorite
      : textMap.favorited;
  }
}

var initGrid = function () {
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  const wishlistLink = document.querySelector('.wishlist_link');
  if (wishlist.length > 0) {
    wishlistLink.classList.remove('blank_wl');
  } else {
    if (!wishlistLink.classList.contains('blank_wl')) {
      wishlistLink.classList.add('blank_wl');
    }
  }
  return setWishlist(wishlist);
};


var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};